module.exports = __webpack_public_path__ + "static/media/bet-logo-9lotto.8c62aefa.png";